import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/notaDebito';
import NDForm from './NDFormTabs';


const ms2p = (state) => {
  return {
    ...state.nota_debito,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NDForm);
